import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import Login from './pages/login/Login';
import Register from './pages/register/Register';
import Transactions from './pages/transactions/Transactions';
import Home from './pages/home/Home';
import UpdateCash from './pages/updatecash/UpdateCash';
import Header from './components/header/Header';
import Stats from './pages/stats/Stats';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const token = Cookies.get('token');
    if (token) {
      setIsLoggedIn(true);
    }
    setIsLoading(false);
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <Header setIsLoggedIn={setIsLoggedIn} />
      <Routes>
        <Route path='/register' element={<Register />} />
        <Route path='/' element={isLoggedIn ? <Navigate to="/home" /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
        <Route
          path='/home'
          element={isLoggedIn ? <Home /> : <Navigate to="/" />}
        />        
        <Route
          path='/transactions'
          element={isLoggedIn ? <Transactions isLoggedIn={isLoggedIn} /> : <Navigate to="/" />}
        />
        <Route
          path='/update-cash-data'
          element={isLoggedIn && Cookies.get('type') === '0' ? (
            <UpdateCash isLoggedIn={isLoggedIn} />
          ) : (
            <Navigate to="/home" />
          )}
        />
        <Route
          path='/stats'
          element={isLoggedIn && Cookies.get('type') === '0' ? (
            <Stats isLoggedIn={isLoggedIn} />
          ) : (
            <Navigate to="/home" />
          )}
        />      
      </Routes>
    </Router>
  );
}

export default App;
